import React, { useState, useEffect } from 'react';
import Slider from 'react-slick'; // Sliderコンポーネントをインポート
import { Helmet } from 'react-helmet-async'; // ★これと
import "./Style/loadingAnimation.css";
import Loading from './Loading';
import styled from 'styled-components';
import Topics from './Topics';
import DocumentRequest from './DocumentRequest';
import Access from './Access';
import Approach from './Approach';
// import Mentenance from './Mentenance';
import { device } from '../MainContents/Style/StyleDevice';
import topImagePc2 from "../../img/highSchoolBnr.png";
import topImageSp2 from "../../img/highSchoolBnr.png";
import topWinter from "../../img/winter.jpg";
import nijiTaisaku from "../../img/nijitaisaku.jpg";
import topImagePc from "../../img/top3.png";
import topImageSp from "../../img/top3.png";
import daiitiSetumeikai from "../../img/daiitiSetumeikai.png";

// スタイル定義は変更なし
const DivTop = styled.div`
  margin-top: 170px;
  @media ${device.mobile}{
    margin-top: 80px;
  }
`;

const HeadingTitle = styled.div`
  text-align: left;
  font-size: 55px;
  font-weight: 500;
  line-height: 1.5em;
  color: #9b003f;
  margin-bottom: 30px;
  @media ${device.mobile} {
    font-size: 26px;
    margin-bottom: 10px;
    padding-left: 20px;
    padding-top: 18px;
  }
`;


const Main = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Sliderのセッティング
  // 今回はトップ画像をスライドさせるため、既存のsettingsを使用
  var settings = {
    dots: true, // ドットのナビゲーションを表示
    infinite: true, // 無限ループ
    speed: 500, // スライドの速度
    slidesToShow: 1, // 一度に表示するスライドの数
    slidesToScroll: 1, // 一度にスクロールするスライドの数
    autoplay: true, // 自動再生を有効にする
    autoplaySpeed: 3000, // 自動再生の間隔（ミリ秒）
    arrows: false, // 左右の矢印ナビゲーションを非表示（必要ならtrueに）
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 画面幅に応じて表示する画像を切り替えるロジック
  // スライダーに複数の画像を持たせるため、配列で管理します
  const topImagesPc = [
    // { src:  topImagePc , link: "/kouza/"},
    { src:  daiitiSetumeikai, link: "/mail/openCampusMail.php" },
    { src:  topImagePc2, link: "/TosayobiHighSchool" }
    
  ];
  const topImagesSp = [
    // { src: topImageSp , link: "/kouza/" },
    { src:  daiitiSetumeikai, link: "/mail/openCampusMail.php" },
    { src: topImageSp2, link: "/TosayobiHighSchool" }

  ];
  // const topImagesPc = [topSummer]; // PC用のスライド画像配列
  // const topImagesSp = [topSummer]; // スマホ用のスライド画像配列

  // 現在の画面幅に応じた画像配列を選択
  const currentImages = windowWidth <= 768 ? topImagesSp : topImagesPc;

  return (
    <DivTop>
      <Loading />
      {/* <Mentenance /> */}
            {/* ★ここからHelmetの記述を追加します */}
            <Helmet>
                <title>土佐塾予備校 高知での実績No.1予備校</title> {/* ←ここに希望するタイトルを設定 */}
                <meta name="description" content="JR高知駅から徒歩5分と最高の交通アクセス！！ 本校は県内唯一の学校法人の予備校です。 公共交通機関の学割制度を利用できるので、経済的に負担も大幅に軽減できます。" />
                {/* 必要であれば、OGPタグなどもここに追加できます */}
                {/* <meta property="og:title" content="TOSAYOBI高等学院" /> */}
                {/* <meta property="og:description" content="高知の通信制高校です。" /> */}
                {/* <meta property="og:url" content="http://localhost:3000/TosayobiHighSchool" /> */}
                {/* <meta property="og:image" content="ここにOGP画像のURL" /> */}
            </Helmet>


      {/* Sliderコンポーネントで画像をラップ */}
      <Slider {...settings}>
        {currentImages.map((imageObj, index) => (
          <div key={index}>
            <a href={imageObj.link}>
              <img src={imageObj.src} alt={`Top Image ${index + 1}`} className="w-full" />
            </a>
          </div>
        ))}
      </Slider>
      
      <Topics />
      <Approach />
      <DocumentRequest />
      <Access />
    </DivTop>
  );
}

export default Main;